<mat-dialog-content class="mat-typography">
  <ng-container *ngIf="oddtype; else loader">
    <div style="float: right">
      <app-copy-entity-link
        [link]="'/oddtypes/' + oddtype.guid"
      ></app-copy-entity-link>
    </div>
    <h1 class="mat-display-1" style="text-align: center">
      {{ oddtype?.name ?? "" }}
    </h1>
    <div *ngIf="!oddtype">
      <mat-spinner></mat-spinner>
    </div>
    <div *ngIf="oddtype">
      <div style="flex: 1; display: flex">
        <div style="flex: 1">
          <p><strong>Guid : </strong>
            {{ oddtype.guid }}
            <app-copy-entity-data
              [data]="'' + oddtype.guid"
            ></app-copy-entity-data>
          </p>
          <p><strong>Nom : </strong>{{ oddtype.name }}</p>
          <p><strong>Sport : </strong>{{ oddtype.sport?.name }}</p>
        </div>
      </div>
      <mat-divider style="margin: 10px 0"></mat-divider>
    </div>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Retour</button>
</mat-dialog-actions>

<ng-template #loader>
  <div class="spinner-wrapper">
    <mat-spinner class="spinner"></mat-spinner>
  </div>
</ng-template>
